"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get InstanceCommands () {
        return InstanceCommands;
    },
    get InstanceTypes () {
        return InstanceTypes;
    },
    get JOBS_QUEUE () {
        return JOBS_QUEUE;
    },
    get JOB_REQUEUED () {
        return JOB_REQUEUED;
    },
    get JOB_REQUEUE_LIMIT () {
        return JOB_REQUEUE_LIMIT;
    },
    get JobEvents () {
        return JobEvents;
    },
    get JobStatus () {
        return JobStatus;
    },
    get JobTypes () {
        return JobTypes;
    },
    get JobVersions () {
        return JobVersions;
    },
    get MigrationJobTypes () {
        return MigrationJobTypes;
    },
    get SKIP_STORING_JOB_META () {
        return SKIP_STORING_JOB_META;
    }
});
var _process_env_NC_ENV, _process_env_NC_ENV1;
const JOBS_QUEUE = 'jobs';
var MigrationJobTypes = /*#__PURE__*/ function(MigrationJobTypes) {
    MigrationJobTypes["Attachment"] = "attachment";
    MigrationJobTypes["Thumbnail"] = "thumbnail";
    MigrationJobTypes["RecoverLinks"] = "recover-links";
    MigrationJobTypes["CleanupDuplicateColumns"] = "cleanup-duplicate-columns";
    MigrationJobTypes["NoOpMigration"] = "no-op-migration";
    MigrationJobTypes["OrderColumnCreation"] = "order-column-creation";
    MigrationJobTypes["RecoverOrderColumnMigration"] = "recover-order-column-migration";
    MigrationJobTypes["RecoverDisconnectedTableNames"] = "recover-disconnected-table-names";
    MigrationJobTypes["AuditMigration"] = "audit-migration";
    return MigrationJobTypes;
}({});
var JobTypes = /*#__PURE__*/ function(JobTypes) {
    JobTypes["DuplicateBase"] = "duplicate-base";
    JobTypes["DuplicateModel"] = "duplicate-model";
    JobTypes["DuplicateColumn"] = "duplicate-column";
    JobTypes["DuplicateDashboard"] = "duplicate-dashboard";
    JobTypes["AtImport"] = "at-import";
    JobTypes["MetaSync"] = "meta-sync";
    JobTypes["MetaDiff"] = "meta-diff";
    JobTypes["SourceCreate"] = "source-create";
    JobTypes["SourceDelete"] = "source-delete";
    JobTypes["UpdateModelStat"] = "update-model-stat";
    JobTypes["UpdateWsStat"] = "update-ws-stats";
    JobTypes["UpdateSrcStat"] = "update-source-stat";
    JobTypes["HealthCheck"] = "health-check";
    JobTypes["HandleWebhook"] = "handle-webhook";
    JobTypes["CleanUp"] = "clean-up";
    JobTypes["DataExport"] = "data-export";
    JobTypes["DataExportCleanUp"] = "data-export-clean-up";
    JobTypes["ThumbnailGenerator"] = "thumbnail-generator";
    JobTypes["AttachmentCleanUp"] = "attachment-clean-up";
    JobTypes["InitMigrationJobs"] = "init-migration-jobs";
    JobTypes["UseWorker"] = "use-worker";
    JobTypes["CreateSnapshot"] = "create-snapshot";
    JobTypes["RestoreSnapshot"] = "restore-snapshot";
    JobTypes["ListenImport"] = "listen-import";
    JobTypes["SyncModuleSyncData"] = "sync-module-sync-data";
    JobTypes["SyncModuleMigrateSync"] = "sync-module-migrate-sync";
    JobTypes["SyncModuleRefreshData"] = "sync-module-refresh-data";
    JobTypes["SyncModuleSchedule"] = "sync-module-schedule";
    JobTypes["UpdateUsageStats"] = "update-usage-stats";
    JobTypes["CloudDbMigrate"] = "cloud-db-migrate";
    JobTypes["AttachmentUrlUpload"] = "attachment-url-upload";
    JobTypes["ExecuteAction"] = "execute-action";
    JobTypes["ReseatSubscription"] = "reseat-subscription";
    JobTypes["ExecuteWorkflow"] = "execute-workflow";
    JobTypes["WorkflowCronSchedule"] = "workflow-cron-schedule";
    JobTypes["WorkflowResumeSchedule"] = "workflow-resume-schedule";
    JobTypes["ResumeWorkflow"] = "resume-workflow";
    JobTypes["TestWorkflowNode"] = "test-workflow-node";
    JobTypes["HeartbeatWorkflow"] = "heartbeat-workflow";
    JobTypes["PollWorkflow"] = "poll-workflow";
    JobTypes["WorkflowErrorNotification"] = "workflow-error-notification";
    return JobTypes;
}({});
const SKIP_STORING_JOB_META = [
    "health-check",
    "thumbnail-generator",
    "use-worker",
    "handle-webhook",
    "execute-workflow",
    "init-migration-jobs",
    "update-model-stat",
    "update-ws-stats",
    "update-source-stat",
    "update-usage-stats",
    "sync-module-schedule",
    "reseat-subscription",
    "workflow-cron-schedule",
    "workflow-resume-schedule",
    "resume-workflow",
    "heartbeat-workflow",
    "poll-workflow",
    "workflow-error-notification"
];
var JobStatus = /*#__PURE__*/ function(JobStatus) {
    JobStatus["COMPLETED"] = "completed";
    JobStatus["WAITING"] = "waiting";
    JobStatus["ACTIVE"] = "active";
    JobStatus["DELAYED"] = "delayed";
    JobStatus["FAILED"] = "failed";
    JobStatus["PAUSED"] = "paused";
    JobStatus["REFRESH"] = "refresh";
    JobStatus["REQUEUED"] = "requeued";
    return JobStatus;
}({});
var JobEvents = /*#__PURE__*/ function(JobEvents) {
    JobEvents["STATUS"] = "job.status";
    JobEvents["LOG"] = "job.log";
    return JobEvents;
}({});
const JobVersions = {
    ["init-migration-jobs"]: 2
};
const JOB_REQUEUED = 'job.requeued';
const JOB_REQUEUE_LIMIT = 10;
const InstanceTypes = {
    PRIMARY: `${(_process_env_NC_ENV = process.env.NC_ENV) != null ? _process_env_NC_ENV : 'default'}-primary`,
    WORKER: `${(_process_env_NC_ENV1 = process.env.NC_ENV) != null ? _process_env_NC_ENV1 : 'default'}-worker`
};
var InstanceCommands = /*#__PURE__*/ function(InstanceCommands) {
    InstanceCommands["RESUME_LOCAL"] = "resumeLocal";
    InstanceCommands["PAUSE_LOCAL"] = "pauseLocal";
    InstanceCommands["RELEASE"] = "release";
    InstanceCommands["ASSIGN_WORKER_GROUP"] = "assignWorkerGroup";
    InstanceCommands["STOP_OTHER_WORKER_GROUPS"] = "stopOtherWorkerGroups";
    return InstanceCommands;
}({});
